/**
 * Administrador de Tema Visual (Claro / Oscuro)
 * Permite cambiar y recordar la preferencia estética del usuario.
 * Cumple con .idx-rules.md: funciones cortas.
 */

const THEME_KEY = 'dni_reader_theme';

/**
 * Inicializa el tema visual leyendo la configuración previa o por defecto.
 * Registra eventos de click en ambos botones (sidebar + mobile header).
 */
export function initTheme() {
  const currentTheme = localStorage.getItem(THEME_KEY) || 'light';
  applyTheme(currentTheme);

  // Botón de tema en el sidebar
  document.getElementById('btn-theme-toggle')?.addEventListener('click', () => {
    const isLight = document.documentElement.classList.contains('light-mode');
    applyTheme(isLight ? 'dark' : 'light');
  });

  // Botón de tema compacto en el header móvil
  document.getElementById('btn-theme-mobile')?.addEventListener('click', () => {
    const isLight = document.documentElement.classList.contains('light-mode');
    applyTheme(isLight ? 'dark' : 'light');
  });
}

/**
 * Aplica el tema visual al elemento raíz HTML y sincroniza los botones.
 * @param {string} theme 'light' o 'dark'
 */
function applyTheme(theme) {
  const label = document.getElementById('theme-toggle-label');
  const mobileIcon = document.getElementById('theme-mobile-icon');

  if (theme === 'light') {
    document.documentElement.classList.add('light-mode');
    localStorage.setItem(THEME_KEY, 'light');
    if (label) label.textContent = 'Modo Oscuro';
    if (mobileIcon) mobileIcon.textContent = '🌙';
  } else {
    document.documentElement.classList.remove('light-mode');
    localStorage.setItem(THEME_KEY, 'dark');
    if (label) label.textContent = 'Modo Claro';
    if (mobileIcon) mobileIcon.textContent = '☀️';
  }
}
